import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { FormControl } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';

import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import { FollowUpService, SubscribeService } from '../../../services/index';
import { ServiceWalkInModel } from '../../../model/index';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
    selector: 'addeditsalesbillentry-tab',
    templateUrl: './customerSatisfiedApproval.component.html',
})
export class CustomerSatisfiedApprovalComponent implements OnInit {

    isLoadMask: Promise<any>;
    serviceWalkInData: ServiceWalkInModel[];
    loadingIndicator: boolean = true;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    bsModalRef: BsModalRef;
    statusCusCtrl: FormControl;
    columns = [];
    toggleCol = [];
    filterData = {
        "search_data": "",
        "from_date": new Date(),
        "to_date": new Date(),
        "user_role_type": ''
    };
    scrollTimeout: any;
    suppressPaging: boolean = false;
    subscribeAuth;
    showManageButton: boolean;
    branchCtrl: FormControl;
    filteredBranch: Observable<any[]>;
    branchList: any[];
    isLoading: boolean = false;

    constructor(public store: Store<fromRootStore.State>, public toasterService: ToasterService,
        private followUpSevice: FollowUpService, public subscribeService: SubscribeService,
        private modalService: BsModalService) {
        this.statusCusCtrl = new FormControl();
        this.showManageButton = false;
    }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellClass: 'cell-center', cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Client No.', prop: 'client_no', width: 210, minWidth: 210, maxWidth: 210 },
            { name: 'Client Name', prop: 'client_name', width: 210, minWidth: 210, maxWidth: 210 },
            { name: 'Mobile', prop: 'mobile', width: 150, minWidth: 150, maxWidth: 150, },
            { name: 'Feedback', prop: 'sold_feedback', width: 150, minWidth: 150, maxWidth: 150, },
            { name: 'Date', prop: 'disp_date', width: 150, minWidth: 150, maxWidth: 150, },
            { name: 'Action', prop: 'action', width: 280, minWidth: 280, maxWidth: 280, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];
        this.getSatisficationApprovalList()
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getSatisficationApprovalList();
    }

    clearFilter(): void {
        this.filterData = {
            "search_data": "",
            "from_date": new Date(),
            "to_date": new Date(),
            "user_role_type": ''
        };
        this.applyFilter();
    }

    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getSatisficationApprovalList();
    }

    saveApproval(row: any, type: string): void {
        let that = this;
        let data = row
        data['status_type'] = type;
        // data['stockDet'] = JSON.stringify(row['data']);
        this.isLoading = true;
        this.followUpSevice
            .saveCustomerSatisficationApproval(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.getSatisficationApprovalList();
                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });

    }

    getSatisficationApprovalList() {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            //filter: JSON.stringify(this.filterData),
            search_data: this.filterData['search_data'],
            from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
            from_page: this['params']['tabParams'],
            branch_id: this.filterData['branch_id']
        };
        let that = this;
        this.isLoadMask = this.followUpSevice
            .getSatisficationApprovalList(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.serviceWalkInData = res.data;
            });
    }
}





// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/customerSatisfiedApproval/customerSatisfiedApproval.component.ts